import {ValueObject} from '@s-ui/domain'

export default class PaymentMethodsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array} data.paymentMethods
   * @param {Array} data.paymentMethods.details
   * @param {String} data.paymentMethods.name
   * @param {String} data.paymentMethods.type
   * */
}
